export const FRANCE_REGIONS = [
  { value: 'auvergne-rhone-alpes', label: 'Auvergne-Rhône-Alpes' },
  { value: 'bourgogne-franche-comte', label: 'Bourgogne-Franche-Comté' },
  { value: 'bretagne', label: 'Bretagne' },
  { value: 'centre-val-de-loire', label: 'Centre-Val de Loire' },
  { value: 'corse', label: 'Corse' },
  { value: 'grand-est', label: 'Grand Est' },
  { value: 'hauts-de-france', label: 'Hauts-de-France' },
  { value: 'ile-de-france', label: 'Île-de-France' },
  { value: 'normandie', label: 'Normandie' },
  { value: 'nouvelle-aquitaine', label: 'Nouvelle-Aquitaine' },
  { value: 'occitanie', label: 'Occitanie' },
  { value: 'pays-de-la-loire', label: 'Pays de la Loire' },
  { value: 'provence-alpes-cote-d-azur', label: "Provence-Alpes-Côte d’Azur" },
  { value: 'guadeloupe', label: 'Guadeloupe' },
  { value: 'martinique', label: 'Martinique' },
  { value: 'guyane', label: 'Guyane' },
  { value: 'la-reunion', label: 'La Réunion' },
  { value: 'mayotte', label: 'Mayotte' },
];

const LEGACY_REGION_ALIASES = {
  aquitaine: 'nouvelle-aquitaine',
  'nouvelle aquitaine': 'nouvelle-aquitaine',
  paca: 'provence-alpes-cote-d-azur',
  'provence-alpes-côte-d’azur': 'provence-alpes-cote-d-azur',
  'provence-alpes-cote-d-azur': 'provence-alpes-cote-d-azur',
  reunion: 'la-reunion',
  'la réunion': 'la-reunion',
};

const slugify = (value = '') => String(value)
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[’']/g, '-')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const normalizeRegionCode = (value = '') => {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  if (LEGACY_REGION_ALIASES[raw]) return LEGACY_REGION_ALIASES[raw];
  const slug = slugify(raw);
  if (LEGACY_REGION_ALIASES[slug]) return LEGACY_REGION_ALIASES[slug];
  return FRANCE_REGIONS.some((region) => region.value === slug) ? slug : slug;
};

export const regionLabel = (value = '') => {
  const normalized = normalizeRegionCode(value);
  return FRANCE_REGIONS.find((region) => region.value === normalized)?.label
    || String(value || '').trim()
    || 'Région non renseignée';
};

export const regionOptions = FRANCE_REGIONS;

export const normalizeRegionList = (values = []) => [...new Set(
  (Array.isArray(values) ? values : [values])
    .map(normalizeRegionCode)
    .filter(Boolean),
)];
